//  icons
import {
  FiYoutube,
  FiInstagram,
  FiGithub,
  FiDribbble,
  FiLayout,
  FiSettings,
  FiPenTool,
  FiTag,
  FiMail,
  FiMapPin,
} from 'react-icons/fi';

// companies icons
import FreelancerBrandIcon from './assets/img/brands/freelancer.png';
import UpworkBrandIcon from './assets/img/brands/upwork.png';
import FiverBrandIcon from './assets/img/brands/fiverr.png';
import BehanceBrandIcon from './assets/img/brands/behance.png';
import DribbbleBrandIcon from './assets/img/brands/dribbble.png';

// projects images
import Project1 from './assets/img/projects/p1.png';
import Project2 from './assets/img/projects/visa-consultancy-500x500.webp';
import Project3 from './assets/img/projects/edulic.jpg';
import Project4 from './assets/img/projects/study-zone.jpg';
import Project5 from './assets/img/projects/study-zone.jpg';
import Project6 from './assets/img/projects/pic-a-book.jpg';

//projects image
import edulic1 from './assets/img/details/edulic.png';
import edulic2 from './assets/img/details/edulic2.png';
import edulic3 from './assets/img/details/edulic (2).png';
import goship1 from './assets/img/details/goship.png';
import goship2 from './assets/img/details/goship2.png';
import goship3 from './assets/img/details/goship3.png';
import picbook1 from './assets/img/details/pic-a-book1.png';
import picbook2 from './assets/img/details/pic-a-book2.png';
import picbook3 from './assets/img/details/pick-a-book.png';
import studyzone1 from './assets/img/details/studyzone.png';
import studyzone2 from './assets/img/details/studyzone2 (2).png';
import studyzone3 from './assets/img/details/studyzone2.png';
import Winners1 from './assets/img/details/winners.png';
import Winners2 from './assets/img/details/Winners_00004.jpg';
import Winners3 from './assets/img/details/Winners_00004.jpg';



// skills images
import SkillImg1 from './assets/img/skills/html5.png';
import SkillImg2 from './assets/img/skills/css3.png';
import SkillImg3 from './assets/img/skills/js.png';
import SkillImg4 from './assets/img/skills/reactjs.png';
import SkillImg5 from './assets/img/skills/nextjs.png';
import SkillImg6 from './assets/img/skills/nodejs.png';
import SkillImg7 from './assets/img/skills/git.png';
import SkillImg8 from './assets/img/skills/figma.png';

// testimonial images
import TestiImage1 from './assets/img/testimonials/testimonial-1.webp';
import TestiImage2 from './assets/img/testimonials/testimonial-2.webp';
import TestiImage3 from './assets/img/testimonials/testimonial-3.webp';

// navigation
export const navigation = [
  {
    name: 'home',
    href: 'home',
  },
  {
    name: 'about',
    href: 'about',
  },
  {
    name: 'portfolio',
    href: 'portfolio',
  },
  
  
  {
    name: 'contact',
    href: 'contact',
  },
];

// social
export const social = [
  
  {
    icon: <FiInstagram />,
    href: '',
  },
  {
    icon: <FiGithub />,
    href: 'https://github.com/AliMasud05',
  },
  {
    icon: <FiDribbble />,
    href: '',
  },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: '',
  },
  {
    img: UpworkBrandIcon,
    href: '',
  },
  {
    img: FiverBrandIcon,
    href: '',
  },
  {
    img: BehanceBrandIcon,
    href: '',
  },
  {
    img: DribbbleBrandIcon,
    href: '',
  },
];

// projects
export const projectsData = [
  {
    id: '1',
    image: Project1,
    name: 'Winners',
    category: 'UI/UX design',
    link:'https://alimasud05.github.io/Winners/',
    details: 'This is simple ui design projects.Technology: CSS, HTML',
    client:'https://github.com/AliMasud05/Winners',
    server:'',
    imag1:'https://i.ibb.co/wdMDG8w/Winners-00006.jpg',    
    imag2:'https://i.ibb.co/2t9Cc1S/Winners-00004.jpg',    
    imag3:'https://i.ibb.co/2qggxxS/winners.png',    
  },
  {
    id: '2',
    image: Project2,
    name: 'Go-Ship',
    category: 'web development',
    link: 'https://goship-8f8f3.web.app/',
    client: 'https://github.com/AliMasud05/goship-client',
    server: 'https://github.com/AliMasud05/goship-server',
    details: 'This is tour and travel website.Here user take travel service.Without login user can not go every page.User can add any tour service.User can review on product and see it.firebase authentication.Technology: React.js, Node.js, Express.js, MongoDB, Firebase, CSS, HTML',
    imag1: 'https://i.ibb.co/WW76h2Y/goship2.png',
    imag2:'https://i.ibb.co/L0G4HN1/goship.png' ,
    imag3:'https://i.ibb.co/SR4SHZZ/goship3.png' , 
  },
  {
    id: '3',
    image: Project3,
    name: 'Edulic',
    category: 'UI/UX design',
    link:'https://alimasud05.github.io/Edulic/',
    client: 'https://github.com/AliMasud05/Edulic',
    server: '',
    details: 'This is education service website layout .Here user can see our course title and details.Also see our successful student,people feedback and our partner. Technology:  CSS, HTML,Bootstrap',
    imag1:'https://i.ibb.co/MkbKQdT/edulic2.png' ,
    imag2:'https://i.ibb.co/H70RhYQ/edulic.png',
    imag3:'https://i.ibb.co/Xy40QCM/edulic-2.png', 

  },
  
  {
    id: '5',
    image: Project5,
    name: 'Study/Zone',
    category: 'web development',
    link:'https://study-zone-5f30d.web.app/',
    client: 'https://github.com/AliMasud05/study-zone-client',
    server: 'https://github.com/AliMasud05/study-zone-server',
    details: "This is a educational website here user can see course and it's details.User can also download course details page.Technology: React.js, Node.js, Express.js, MongoDB, Firebase, CSS, HTML",
    imag1:'https://i.ibb.co/ZxJXPH0/studyzone2.png' ,
    imag2: 'https://i.ibb.co/YXSpwDF/studyzone2-2.png',
    imag3: 'https://i.ibb.co/GCgS2JQ/studyzone.png', 

  },
  {
    id: '6',
    image: Project6,
    name: 'Pick-A-Book',
    category: 'web development',
    link:'https://pick-a-book-b0be3.web.app/',
    client: 'https://github.com/AliMasud05/pic-a-book-client',
    server: 'https://github.com/AliMasud05/pick-a-book-sever',
    details: 'This is uses book resale website.Here change website layout according to user role such as admin,buyer,seller.User Can buy product and set meeting location.Buyer can promote his book and right to delete own product.Admin can see buyer and seller list and delete anyone.Technology: React.js, Node.js, Express.js, MongoDB, Firebase, CSS, HTML ',
    imag1: 'https://i.ibb.co/j3Xfrfw/pick-a-book.png',
    imag2: 'https://i.ibb.co/gJfD7KL/pic-a-book2.png',
    imag3: 'https://i.ibb.co/cx7j3hB/pic-a-book1.png', 

  },
];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'UI/UX Design',
  },
  {
    name: 'web development',
  },
  
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
];

// services
export const services = [
  {
    icon: <FiLayout />,
    name: 'Web Design',
    description:
      '',
  },
  {
    icon: <FiSettings />,
    name: 'Web Development',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.',
  },
  
  {
    icon: <FiTag />,
    name: 'SEO',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.',
  },
];

// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Google',
  },
  {
    authorImg: TestiImage2,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Google',
  },
  {
    authorImg: TestiImage3,
    authorText:
      'Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.',
    authorName: 'Olivia Doe',
    authorPosition: 'Head of Design, Google',
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: 'Have a question?',
    subtitle: 'I am here to help you.',
    description: 'Email me at morshedalimasud3@gmail.com',
  },
  {
    icon: <FiMapPin />,
    title: 'Current Location',
    subtitle: 'Dhaka,Bangladesh',
    description: 'Serving clients worldwide',
  },
];
